import { computed, Directive, input } from '@angular/core';
import { cn } from '@shared/helpers/cn';

@Directive({
  selector: '[appInputError]',
  standalone: true,
  host: { '[class]': 'styles()' },
})
export class AppInputErrorDirective {
  class = input<string>();

  public styles = computed(() => {
    return cn(
      'mt-1.5 text-sm text-red-600 flex items-center gap-1',
      this.class(),
    );
  });
}
